import { TableDetails } from '../models/databaseObjectTypes';

interface TableViewerProps {
  table?: TableDetails;
  isLoading?: boolean;
}

export function TableViewer({ table, isLoading }: TableViewerProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-muted-foreground">Loading table data...</p>
      </div>
    );
  }

  if (!table) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-muted-foreground">No table selected</p>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col p-4">
      <h2 className="text-xl font-semibold mb-2">
        {table.schema}.{table.name}
      </h2>
      
      <div className="text-sm text-muted-foreground mb-4">
        Table in database - {table.connectionId}
      </div>
      
      <div className="border rounded-md overflow-hidden">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-muted border-b border-border">
              <th className="px-4 py-2 text-left font-medium text-sm">Column Name</th>
              <th className="px-4 py-2 text-left font-medium text-sm">Data Type</th>
              <th className="px-4 py-2 text-left font-medium text-sm">Nullable</th>
              <th className="px-4 py-2 text-left font-medium text-sm">Primary Key</th>
              <th className="px-4 py-2 text-left font-medium text-sm">Foreign Key</th>
              <th className="px-4 py-2 text-left font-medium text-sm">Default</th>
            </tr>
          </thead>
          <tbody>
            {table.columns.map((column, index) => (
              <tr key={column.name} className={index % 2 === 0 ? 'bg-background' : 'bg-muted/50'}>
                <td className="px-4 py-2 border-t border-border font-medium text-sm">{column.name}</td>
                <td className="px-4 py-2 border-t border-border text-sm">
                  {column.dataType}
                  {column.charLength ? `(${column.charLength})` : ''}
                  {column.precision ? `(${column.precision},${column.scale})` : ''}
                </td>
                <td className="px-4 py-2 border-t border-border text-sm">
                  {column.nullable ? 'Yes' : 'No'}
                </td>
                <td className="px-4 py-2 border-t border-border text-sm">
                  {column.isPrimaryKey ? 'Yes' : 'No'}
                </td>
                <td className="px-4 py-2 border-t border-border text-sm">
                  {column.isForeignKey ? 'Yes' : 'No'}
                </td>
                <td className="px-4 py-2 border-t border-border text-sm">
                  {column.defaultValue || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
} 